/**
 * 打开遮罩层查看图片、视频详情
 * 用法：
 * const ShowMedia = require('public/js/show_media.js');
 * ShowMedia.ToggleCover(type,url,callback);
 * @param type <String> "img"/"video" 必填
 * @param url <String> 图片/视频地址 必填
 * @param callback <Function> 打开后的回调,回调值为遮罩层的$对象 选填
 */
class Module{
  constructor(){
    this.Loading = this._Loading;
    this.cover = this._cover;
    this.root = $('body');
    this.root.before(this.cover);
  }

  get _Loading(){
    const LoadingBase64 = 'data:image/gif;base64,R0lGODlhDwAPAPQAAJWVlaqqqr+/v9XV1dnZ2bKyssXFxZ+fn6CgoOHh4efn583NzbOzs97e3u/v7/X19eXl5cbGxu3t7aurq+rq6vPz87y8vAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUP8/eHBhY2tldCBiZWdpbj0i72lkOjQzREFENjZENuHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBRQAEAAsAAAAAA8ADwAABULg0wwkCQkoujhEWZ4parhvnNKmjeIDbPO+GFAngBiPyCRgyQRAAtBooMl8SqHUpfWadV6x2a0UEf4yEgeqOFBQhAAAIfkEBRQACAAsAAAAAA8ADwAABUIgNAEkiQwo2jxHWZ4pSrhvnNKmjeIAbPO+GFA3QBiPyGRgyQwgBNCooMl8SqHUpfWadV6x2a2UEf5GFAWqWGCQhAAAIfkEBRQACAAsAAAAAA8ADwAABUIgZQUkiQAoOkFFWZ4perhvnNKmjeIBbPO+GFAHQBiPyKRgyRQgBtDooMl8SqHUpfWadV6x2a00Ev4SJAaqeECohAAAIfkEBRQACgAsAAAAAA8ADwAABUKgswgkqQQoalFGWZ4pWrhvnNKmjeICbPO+GFAXUBiPyORgyRwoANAooMl8SqHUpfWadV6x2a2UEP4iKuSmGHBIhAAAOw==';
    const style = "style='height:15px;width:15px;margin:50% auto;'";
    return $(`<div ${style} class="m-show-media-cover-loading"><img src="${LoadingBase64}"></div>`);
  }

  createImgElement(url){
    const img = new Image();
    const that = this;
    this.cover.append(this.Loading);
    img.onload = function(){
      that.Loading.remove();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const currentHeight =  this.height/(this.width/windowWidth);
      const marginTop = (windowHeight - currentHeight) / 2;
      const divStyle = "style='height:100%;width:100%;'";
      const imgStyle = `style='position:relative;top:${marginTop}px;width:100%;display:block;'`;
      const $ele = $(`<div ${divStyle} class="m-show-media-cover-img"><img class="cover-img" ${imgStyle} src="${url}"></div>`);
      that.cover.append($ele);
    };
    img.src = url;
    this.cover.on('click',(e)=>{
      this.cover.toggle(false);
      $('.m-show-media-cover-img').remove();
      this.cover.off();
    });
  }

  createVideoElement(url){
    const style = 'style="margin-top:50%"';
    const closeStyle = 'style="margin:0 auto;height:32px;width:32px;margin-top:10%;background:url(data:image/png;base64,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) no-repeat;background-size:cover;"';
    const videoStyle = 'style="height:auto;width:100%"';
    const $ele = $(`<div class="m-show-media-cover-video" ${style} ><video controls autoplay="autoplay" src='${url}' ${videoStyle} /></div>`);
    const $close = $(`<div class="m-show-media-cover-video-close" ${closeStyle} ></div>`);
    this.cover.append($ele);
    this.cover.append($close);
    $close.on('click', (e) => {
      this.cover.toggle(false);
      this.cover.text('');
      $close.off();
    });
  }

  CreateElement(type,url){
    if(type === 'img'){
      this.$ele = this.createImgElement(url);
    } else if (type === 'video'){
      this.$ele = this.createVideoElement(url);
    }
  }

  get _cover(){
    const style = 'style="display:none;z-index:1000;height:100%;width:100%;position:fixed;background:rgba(0, 0, 0, 0.72);"'
    const $cover = $(`<div class="m-show-media-cover" ${style} ></div>`);
    return $cover
  }

  ToggleCover(type,url,callback){
    if(!type||!url) return;
    this.cover.toggle(true);
    this.CreateElement(type,url);
    if(!callback) return;
    callback(this.cover);
  }

}

module.exports = new Module();


// WEBPACK FOOTER //
// ./lib/js/public/show_media.js